import { Button } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { jsonEditorStyles } from '../jsonEditorStyles';
import { cloneDeep } from 'lodash';

interface AddOrEditSubflowProps {
  modifiedData: any;
  submitData: any;
  openSubFlowFC: any;
  setCurrentTabId: any;
  onDeleteSubFlow: any;
  subFlowType: string;
  subFlowDisplayName: string;
  disableSubmit: boolean;
}

const AddOrEditSubflowUI = ({
  modifiedData,
  submitData,
  openSubFlowFC,
  setCurrentTabId,
  onDeleteSubFlow,
  subFlowType,
  subFlowDisplayName,
  disableSubmit,
}: AddOrEditSubflowProps) => {
  const classes = jsonEditorStyles();
  return (
    <>
      {(!modifiedData.hasOwnProperty(subFlowType) || modifiedData[subFlowType]['id'] === '') && (
        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
          onClick={() => submitData(modifiedData, true, subFlowType)}
        >
          Add {subFlowDisplayName}
        </Button>
      )}
      {modifiedData.hasOwnProperty(subFlowType) && modifiedData[subFlowType]['id'] !== '' && (
        <div className={classes.flexRow}>
          <div
            className={classes.pointer}
            onClick={() => {
              if (!disableSubmit) {
                submitData(modifiedData, false);
                window.alert('Saving information in the popup. Click again on the link to navigate.');
              } else {
                openSubFlowFC(modifiedData);
              }
              setCurrentTabId(modifiedData[subFlowType]['id']);
            }}
          >
            {modifiedData[subFlowType]['displayName']} &nbsp;&nbsp;&nbsp;
            <a href="#">Click here to edit {subFlowDisplayName}.</a>
          </div>
          <div>
            <DeleteIcon
              onClick={() => {
                window.confirm(`Are you sure you want to delete the ${subFlowDisplayName} ? This cannot be undone.`) &&
                  onDeleteSubFlow(modifiedData[subFlowType]['id'], subFlowType);
              }}
              className={classes.icon}
              color="error"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default AddOrEditSubflowUI;
